import usePlacesService from "react-google-autocomplete/lib/usePlacesAutocompleteService";
import { AutoCompleteProps, Select, Spin } from "antd";
import { InputWrapper, SplitInputWrapperProps } from "../AntdAddons/functions";
import { FormItemProps } from "antd/lib";
import { toLowerCaseWithUnderscore } from "../../utils/commonFunctions";
import { validations } from "../../config/validations/validations";

interface I
  extends FormItemProps,
    Omit<AutoCompleteProps, "name" | "children" | "status" | "onReset"> {
  setLatLng: any;
}

/**
 * Renders a React functional component for an autocomplete input field that allows the user to select a place using the Google Places API
 * for Using in VR Training Location Form Component to suggest places
.
 *
 * @param {I} props - The props object that contains the necessary data and functions for the component.
 * @param {PlacesService} props.placesService - The PlacesService object from the usePlacesService hook.
 * @param {Array<any>} props.placePredictions - The array of place predictions returned by the PlacesService.
 * @param {Function} props.getPlacePredictions - The function to fetch place predictions from the PlacesService.
 * @param {boolean} props.isPlacePredictionsLoading - A boolean indicating whether the place predictions are currently being loaded.
 * @param {FormItemProps} props.formProps - The props object for the form item.
 * @param {AutoCompleteProps} props.inputProps - The props object for the input component.
 * @param {Function} props.setLatLng - The function to set the latitude and longitude of the selected place.
 * @return {ReactElement} The rendered PlaceAutoCompleteInput component.
 */
const PlaceAutoCompleteInput: React.FC<I> = (props: I) => {
  const {
    placesService,
    placePredictions,
    getPlacePredictions,
    isPlacePredictionsLoading,
  } = usePlacesService({
    apiKey: "AIzaSyBVFPr8rkTqocRs8aKUwi--GLdk6PD2wGY",
    debounce: 500,
    libraries: ["places", "geometry", "drawing", "visualization"],
  });
  const { formProps, inputProps } = SplitInputWrapperProps(props);

  return (
    <>
      <InputWrapper
        name={formProps?.label && toLowerCaseWithUnderscore(formProps.label)}
        rules={formProps?.required ? [validations.required.select()] : []}
        {...formProps}
      >
        <Select
          allowClear
          showSearch
          options={placePredictions.map((data: any) => {
            return {
              place_id: data.place_id,
              label: data.description,
              value: data.description,
            };
          })}
          style={{ width: "100%" }}
          onSearch={value => {
            getPlacePredictions({ input: value });
          }}
          notFoundContent={
            isPlacePredictionsLoading ? (
              <Spin size="default" />
            ) : (
              "No Place Found."
            )
          }
          placeholder={formProps?.label}
          onSelect={(_, option) => {
            placesService?.getDetails(
              {
                placeId: option?.place_id,
              },
              placeDetails =>
                props?.setLatLng({
                  lat: placeDetails?.geometry?.location?.lat(),
                  lng: placeDetails?.geometry?.location?.lng(),
                })
            );
          }}
          {...inputProps}
        />
      </InputWrapper>
    </>
  );
};
export default PlaceAutoCompleteInput;
